var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic/send-mail",
    clipPath: "url(#clip0_79_1675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail-send-email-message--send-email-paper-airplane-deliver"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2311 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0303 0.969661C23.2399 1.17924 23.3064 1.49259 23.2 1.76923L15.1231 22.7692C15.0146 23.0513 14.7474 23.2407 14.4454 23.2497C14.1433 23.2586 13.8654 23.0855 13.7403 22.8103L9.81823 14.1818L1.18965 10.2597C0.914537 10.1346 0.741351 9.85669 0.750333 9.55462C0.759316 9.25256 0.948711 8.98539 1.23077 8.8769L22.2308 0.799982C22.5074 0.693584 22.8208 0.760081 23.0303 0.969661ZM3.43933 9.63458L10.695 12.9326C10.8601 13.0076 10.9924 13.1399 11.0674 13.305L14.3654 20.5607L21.1942 2.80578L3.43933 9.63458Z",
    fill: "#AB78FF",
    stroke: "#AB78FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2312 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.761 8.2389C16.0539 8.53179 16.0539 9.00666 15.761 9.29956L10.9149 14.1457C10.622 14.4386 10.1471 14.4386 9.85419 14.1457C9.5613 13.8528 9.5613 13.3779 9.85419 13.0851L14.7003 8.2389C14.9932 7.946 15.4681 7.946 15.761 8.2389Z",
    fill: "#AB78FF",
    stroke: "#AB78FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_1675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendbtn);
export default __webpack_public_path__ + "static/media/sendbtn.b4cef45ce158067c6f95daba655521d8.svg";
export { ForwardRef as ReactComponent };